import { animate, style, transition, trigger } from '@angular/animations';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Key } from '../../../../../global/enum/global.enum';
import { DeleteWarningMessageComponent } from '../../../delete-warning-message/delete-warning-message.component';
import { Language, NavSideItem } from '../../interfaces/nav.interfaces';
import { navSideData } from '../../nav-data';

@Component({
    selector: 'app-nav-side',
    templateUrl: './nav-side.component.html',
    styleUrl: './nav-side.component.scss',
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('160ms ease-out', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('100ms ease-in', style({ opacity: 0 })),
            ]),
        ]),
        trigger('iconInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('160ms ease-out', style({ opacity: 1 })),
            ]),
        ]),
    ],
    standalone: false
})
export class NavSideComponent implements OnInit {
  @Output() onToggleSideNav: EventEmitter<any> = new EventEmitter();
  @Output() languageSelection: EventEmitter<Language> = new EventEmitter();
  @Input() collapsed = false;
  public screenWidth = 0;
  public navData: NavSideItem[] = navSideData;
  public openedSubMenuLabel: string | null = 'admin.careers';

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    if (this.isMobileViewport()) {
      this.collapsed = true;
    }
    this.emitSideNavState();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    const previousWidth = this.screenWidth;
    this.screenWidth = (event.target as Window).innerWidth;
    const crossedIntoMobile = previousWidth > 768 && this.isMobileViewport();
    const crossedIntoDesktop = previousWidth <= 768 && !this.isMobileViewport();

    if (crossedIntoMobile) {
      this.collapsed = true;
    } else if (crossedIntoDesktop) {
      this.collapsed = false;
    }

    this.emitSideNavState();
  }

  public toggleCollapse(): void {
    this.collapsed = !this.collapsed;
    this.emitSideNavState();
  }

  public closeSideNav(): void {
    this.collapsed = true;
    this.emitSideNavState();
  }

  public onNavLinkClick(): void {
    if (this.isMobileViewport()) {
      this.closeSideNav();
    }
  }

  public toggleSubMenu(label: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.openedSubMenuLabel = this.openedSubMenuLabel === label ? null : label;
  }

  public isSubMenuOpen(label: string): boolean {
    return this.openedSubMenuLabel === label;
  }

  public getLogOut(): void {
    this.dialog
      .open(DeleteWarningMessageComponent, {
        data: {
          warningMessage: 'deleteWarning.logout',
        },
      })
      .afterClosed()
      .subscribe((isApprove: any) => {
        if (!isApprove) {
          return;
        }
        localStorage.removeItem(Key.TOKEN);
        localStorage.removeItem(Key.REFRESH_TOKEN);

        setTimeout(() => {
          location.reload();
        }, 100);
      });
  }

  private isMobileViewport(): boolean {
    return this.screenWidth <= 768;
  }

  private emitSideNavState(): void {
    this.onToggleSideNav.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }
}
